import { SEO } from "@/components/SEO";
import { PageHero } from "@/components/PageHero";
import { CTASection } from "@/components/CTASection";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";
import { IMAGES } from "@/config/images";

const VALUES = [
  { title: "Coordinate", copy: "Tenants, vendors, societies, service providers — one point of contact for everything." },
  { title: "Inspect", copy: "Physical presence at your property with documented, visual verification." },
  { title: "Communicate", copy: "Clear, structured updates — WhatsApp-first, in your time zone." },
  { title: "Document", copy: "Photos, videos, invoices and records for everything we do." },
  { title: "Execute", copy: "Work completed on the ground — after your approval, with proof." },
];

export default function About() {
  return (
    <>
      <SEO
        title="About Us | NRI Property Services Hyderabad"
        description="NRI Property Services — built for property owners who can't always be there. A professional local presence in Hyderabad. A Quality Expertz Group Company."
        path="/about"
      />
      <PageHero
        eyebrow="About Us"
        titleLines={["Built for Property Owners", "Who Can't Always Be There"]}
        copy="Owning a property in Hyderabad is easy. Managing it from another country is not."
        note="NRI Property Services · A Quality Expertz Group Company"
      />

      <section className="bg-ivory py-24 sm:py-32">
        <div className="container-site grid gap-14 lg:grid-cols-2 lg:gap-20">
          <Reveal>
            <div className="frame-arch h-[420px] overflow-hidden border border-navy-900/10 sm:h-[540px]">
              <img
                src={IMAGES.hyderabad}
                alt="Hyderabad city skyline"
                className="duotone h-full w-full object-cover"
                loading="lazy"
              />
            </div>
          </Reveal>
          <div className="flex flex-col justify-center">
            <Reveal>
              <p className="text-base leading-relaxed text-navy-900/80 sm:text-lg">
                NRI Property Services was created to solve a simple but important problem: tenants, rent,
                maintenance, repairs, cleaning, inspections, documentation and unexpected problems can
                quickly become a full-time responsibility — especially from thousands of kilometres away.
              </p>
              <p className="mt-6 text-base leading-relaxed text-navy-900/80 sm:text-lg">
                Our role is to bridge that distance. We provide a professional local presence for property
                owners who cannot be physically present in Hyderabad.
              </p>
              <p className="mt-6 text-base leading-relaxed text-navy-900/80 sm:text-lg">
                We coordinate, inspect, communicate, document and execute — so owners can remain informed
                and in control without being physically present.
              </p>
              <p className="mt-6 border-l-2 border-gold-500 pl-6 font-display text-lg font-bold leading-snug tracking-tight text-navy-900 sm:text-xl">
                We are part of the Quality Expertz Group, bringing access to professional execution
                capabilities across property maintenance, interiors and related services.
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="bg-navy-900 py-24 sm:py-32">
        <div className="container-site">
          <Reveal>
            <div className="flex items-center gap-4">
              <span className="gold-rule" aria-hidden="true" />
              <span className="eyebrow">What We Do, Every Day</span>
            </div>
          </Reveal>
          <Stagger className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-5" gap={0.08}>
            {VALUES.map((v) => (
              <StaggerItem key={v.title}>
                <div className="h-full rounded-2xl border border-white/10 bg-white/[0.04] p-6">
                  <h3 className="font-display text-lg font-extrabold tracking-tight text-gold-400">{v.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-white/60">{v.copy}</p>
                </div>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>

      <CTASection />
    </>
  );
}
